import { render, staticRenderFns } from "./UserChart1.vue?vue&type=template&id=02889e52&"
import script from "./UserChart1.vue?vue&type=script&lang=js&"
export * from "./UserChart1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports